<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WAJvvI/tc-custom/9781504090667.jpg?1731155998780" alt="This image is the cover for the book Murder on Sagebrush Lane, Harrie McKinsey Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder on Sagebrush Lane, Harrie McKinsey Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A murder on a quiet street in Albuquerque leads a psychic amateur sleuth and her FBI agent husband into an investigation of stolen government secrets.</b><br/>  <br/> Trouble always seems to find Harrie McKinsey. From the darkness that haunts her dreams at night, to the morning she discovers a toddler sitting in the flower bed on her front porch, covered in blood. A search for the little girl’s parents leads Harrie and her husband, FBI agent DJ Scott, into a grisly murder investigation of the child’s father, a computer lab employee at Sandia National Labs with a security clearance at the highest government levels.<br/>  <br/> Whatever Katie’s father knew, it led to his brutal death. And now with the child’s life at stake, Harrie won’t sit still until the killer is caught. Along with DJ, her best friend Ginger, and Ginger’s husband, Harrie is drawn into a world where there are those who would stop at nothing shy of theft, kidnapping, and murder to gain power. Harrie might just be in over her head this time. But that doesn’t stop her from pursuing a killer who intends to make her his final victim.<br/>  <br/> “Filled with tension and suspense. . . . This is Patricia Wood’s best book yet.” —Joseph Badal, Hillerman Prize–winning author of <i>Ultimate Betrayal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Smith Wood
      </h2>
      
      <p class="authorDescription body article">Patricia Smith Wood became an FBI agent for a brief period, following in her father&rsquo;s footsteps who had a distinguished career at the bureau. She also worked as an executive assistant in hospital administration, and then in telecommunications, bank security, and computer technology. Eventually she became president of her own computer company until she and her husband sold the business in 2006. Since then, she&rsquo;s devoted her time to writing mystery novels. She lives in Albuquerque with her husband, Don</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49b60869